import React from 'react'
import { AiOutlineEye } from "react-icons/ai";
import { motion } from 'framer-motion'



const DetailsCard = ({data, onClick, index}) => {
  return (
    <motion.div
     initial={{ scale: 0.1, opacity: 0, }}
     animate={{ scale: 1, opacity: 1 }}
     transition={{ duration: 0.5, delay: index * 0.1, easing: "easeInOut" }}
    //  whileHover={{ scale: 1.05, y: 7 }}
     className={`flex flex-col items-center justify-center w-[47%] h-32 px-3 mb-5 odd:nth-child(2n+1):ml-20 rounded-md border-[1px] border-[#DDE1E6] bg-[#F9FAFB]
                   cursor-pointer md:w-[29%] md:mr-6 md:nth-child(3n):mr-0 md:mb-8 md:h-40 lg:mb-9 lg:w-[30%]
                   xl:h-48 xl:w-[23%] xl:mb-8 xl:mr-5 xl:rounded-lg`}>
        <div className='flex items-center justify-center h-9 w-9 p-1.5 rounded-full bg-white md:h-11 md:w-11 md:p-2.5 lg:p-2.5 xl:h-[50px] xl:w-[50px] xl:p-2.5'>
           <img className=''
           src={data.icon} alt={data.alt} />
        </div>

        <p className='text-[11px] text-center font-medium text-[#667085] mt-2 md:text-[12px] md:mt-3 xl:text-sm xl:mt-[14px]'>
            {data.name}
        </p>

        <div onClick={onClick}
        className='flex items-center justify-center px-3 py-1.5 mt-2 cursor-pointer rounded-md bg-[#25A249] md:px-3 md:mt-2.5 lg:px-4 lg:py-2 xl:w-[145px] xl:mt-3'>
              <p className='text-[11px] text-center font-semibold text-[#ffffff] mr-2 md:text-[12px] md:mr-3 xl:text-[13px]'>
                  View details                 
              </p>
              <AiOutlineEye className='text-white text-sm lg:text-base xl:text-lg' />
        </div>

    </motion.div>
  )
}

export default DetailsCard
